import React from 'react';
import {RouteLoader} from '@dofleini/security';
import {routes} from './routes.constant';
import SocialRoute from '../components/SocialRoute';


const ModuleRoutes = () => {
  return (
    <React.Fragment>
      <SocialRoute path="/callback"/>
      <RouteLoader routes={routes} notfoundRedirect={'/'}/>
    </React.Fragment>
  );
};

ModuleRoutes.propTypes = {};

ModuleRoutes.defaultProps = {};

export default ModuleRoutes;
